import Image from '@components/Image/Image'
import { resolveCdnMediaUrl } from '@helpers/cdnMediaUrl'
import React, { FunctionComponent, memo, useCallback, useState } from 'react'
import './GraphicCell.scss'

interface GraphicCellProps {
  graphicSrc: string
  selected?: boolean
  size?: number
  label?: string
  showLabel?: boolean
  fallbackGraphicSrc?: string
  labeSize?: 'small' | 'medium' | 'large'
  labelPosition?: 'relative' | 'absolute'
}

const GraphicCell: FunctionComponent<GraphicCellProps> = ({ graphicSrc, selected, size = 96, showLabel, label, fallbackGraphicSrc, labeSize = 'medium', labelPosition = 'absolute' }) => {
  const [fallback, setFallback] = useState(false)
  const primarySrc = resolveCdnMediaUrl(graphicSrc)
  const resolvedFallback = fallbackGraphicSrc ? resolveCdnMediaUrl(fallbackGraphicSrc) : undefined

  const GraphicImage = useCallback(() => {
    if (fallback && resolvedFallback) {
      return <Image src={resolvedFallback} />
    }

    if (fallback) {
      return null
    }

    return <Image src={primarySrc} onError={() => setFallback(true)} />
  }, [fallback, primarySrc, resolvedFallback])

  return (
    <div className={`GraphicCell ${selected ? '-selected' : ''}`} style={{ height: `${size}px`, width: `${size}px` }}>
      <GraphicImage />
      {showLabel && <span className={`label -${labeSize} -${labelPosition}`}>{label}</span>}
    </div>
  )
}

export default memo(GraphicCell)
